module.exports = __webpack_public_path__ + "static/be_cup_hero-184fccf987341eb0c9b1253643c59222.jpg";